export const IFS_CODE_URL = "https://ifsc.razorpay.com/";
